import { publicComponentOption } from "dependencies/base"
import { toSelectOpt } from "utils"
const optDes = {
  ...publicComponentOption,
  opacity: "透明度",
  boxShadowColor: "阴影颜色",
  boxShadowH: "阴影x轴的偏移量",
  boxShadowV: "阴影y轴的偏移量",
  boxShadowBlur: "阴影模糊值",
  boxShadowSpread: "阴影扩散值",
  // viewBox: "可显示区域",
  // pathD: "svg路径",
  "shapeColor.0.colorStops": "形状颜色",
  "shapeBorderColor.0.colorStops": "形状边框颜色",
  // "linearGradient.0": "svg渐变色值id",
  "bgAngleValue.0": "渐变角度"
  // "borderLinearGradient.0": "svg边框渐变色值id",
}
export const getOptDes = toSelectOpt.bind(this, optDes)
